module.exports = __webpack_public_path__ + "img/phone.5e45461.svg";